Shop.api = {
    getPaymentStatus(url) {
        return new Promise(function(resolve, reject) {
            return axios.post('/checkout/step3').then(response => {
                resolve(response.data.status);
            });
        });
    }
};